
<div class="modal-header">
    <h2 class="modal-title">{{'asset.location' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
    </button>
</div>

<div class="modal-body">
    <iframe width="100%" height="380" [src]="mapUrl" style="border:0;" allowfullscreen loading="lazy"></iframe>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="closeModal()">
        {{ "common.closeButton" | translate }}
    </button>
</div>
